import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';
import {
  ABOUT_US_PATH,
  BREEDER_QUALITY_PATH,
  BREEDER_CENTER_PATH,
  COE_BREEDER_PATH,
  COE_PARENT_PATH,
  COE_SHELTER_PATH,
  HELP_CENTER_PATH,
  HELP_PATH,
  LOGIN_PATH,
  JOIN_AS_BREEDER_PATH,
  JOIN_AS_SHELTER_PATH,
  MISSION_PATH,
  PRIVACY_PATH,
  SHELTER_QUALITY_PATH,
  STANDARDS_PATH,
  TOS_PATH,
  HEALTH_TESTING_GUIDE_PATH,
  GOOD_DOG_POD_PATH,
  NONDISCRIMINATION_POLICY_PATH,
  BREED_DIRECTORY_PATH,
  BREEDER_DIRECTORY_PATH,
  CAREERS_PATH
} from 'dpl/shared/constants/urls';
import MobileMenu from 'dpl/components/MobileMenu';

export const SECTIONS = [{
  name: 'about',
  title: 'About Good Dog',
  links: [{
    title: 'About Us',
    href: ABOUT_US_PATH
  }, {
    title: 'Careers',
    href: CAREERS_PATH
  }, {
    title: 'Standards & Screening',
    href: STANDARDS_PATH
  }, {
    title: 'Our Mission',
    href: MISSION_PATH
  }, {
    title: 'Dog Owner Policies',
    href: COE_PARENT_PATH
  }, {
    title: 'Nondiscrimination Policy',
    href: NONDISCRIMINATION_POLICY_PATH
  }]
}, {
  name: 'breeders',
  title: 'Breeders',
  links: [{
    title: 'Join as Breeder',
    href: JOIN_AS_BREEDER_PATH
  }, {
    title: 'Good Breeder Center',
    href: BREEDER_CENTER_PATH
  }, {
    title: 'What\'s a Good Breeder?',
    href: BREEDER_QUALITY_PATH
  }, {
    title: 'Health Testing Levels',
    href: HEALTH_TESTING_GUIDE_PATH
  }, {
    title: 'Breeder Code of Ethics',
    href: COE_BREEDER_PATH
  }]
}, {
  name: 'shelters',
  title: 'Shelters & Rescues',
  links: [{
    title: 'Join as Shelter or Rescue',
    href: JOIN_AS_SHELTER_PATH
  }, {
    title: 'What are Good Shelters or Rescues?',
    href: SHELTER_QUALITY_PATH
  }, {
    title: 'Shelter & Rescue Code of Ethics',
    href: COE_SHELTER_PATH
  }]
}, {
  name: 'good dog pod',
  title: 'The Good Dog Pod',
  href: GOOD_DOG_POD_PATH
}, {
  name: 'help center',
  title: 'Help Center',
  href: HELP_CENTER_PATH
}, {
  name: 'help',
  title: 'Contact Us',
  href: HELP_PATH
}, {
  name: 'legal',
  title: 'Terms & Privacy',
  links: [{
    title: 'Terms of Service',
    href: TOS_PATH
  }, {
    title: 'Privacy',
    href: PRIVACY_PATH
  }]
}, {
  name: 'directory',
  title: 'Directory',
  links: [{
    title: 'Breeds',
    href: BREED_DIRECTORY_PATH
  }, {
    title: 'Breeders',
    href: BREEDER_DIRECTORY_PATH
  }]
}];


export default class GenericMobileHeaderDropdownContent extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool
  };

  static defaultProps = {
    isLoggedIn: false
  };

  state = { shownSection: null }

  handleSectionClick = sectionName => () =>
    this.setState({ shownSection: sectionName });

  handleSectionClose = () =>
    this.setState({ shownSection: null });

  render() {
    const { isLoggedIn } = this.props;
    const { shownSection } = this.state;

    return (
      <div className="GenericMobileHeaderDropdownContent">
        {
          !isLoggedIn &&
            <div className="bt b--light-gray">
              <GenericMobileHeaderDropdownContentSubNav
                href={ LOGIN_PATH }
                name="login"
                title="Log In"
              />
              <GenericMobileHeaderDropdownContentSubNav
                href={ JOIN_AS_BREEDER_PATH }
                name="breeder-signup"
                title="Join as Breeder"
              />
              <GenericMobileHeaderDropdownContentSubNav
                href={ JOIN_AS_SHELTER_PATH }
                name="shelter-signup"
                title="Join as Shelter or Rescue"
              />
            </div>
        }
        {
          SECTIONS.map(({
            href,
            links,
            name,
            title
          }, idx) => (
            <GenericMobileHeaderDropdownContentSubNav
              href={ href }
              isOpen={ shownSection === name }
              key={ idx }
              links={ links }
              name={ name }
              onClose={ this.handleSectionClose }
              onOpen={ links && this.handleSectionClick(name) }
              title={ title }
            />
          ))
        }
      </div>
    );
  }
}

export function GenericMobileHeaderDropdownContentSubNav({
  href,
  isOpen,
  links,
  name,
  onClose,
  onOpen,
  title
}) {
  return (
    <Fragment>
      <a
        className="pv5 bb b--black-10 db flex items-center"
        href={ href }
        key={ name }
        onClick={
          onOpen && ((e) => {
            e.preventDefault();
            onOpen();
          })
        }
      >
        <span className="flex-auto fw-medium">{ title }</span>
        { onOpen && <Icon name="fat-arrow-right" /> }
      </a>
      {
        (links && links.length > 0) &&
          <MobileMenu
            isOpen={ isOpen }
            position="right"
          >
            <div className="pv5 ph4">
              <button
                className="flex items-center black-50 fw-medium"
                onClick={ onClose }
                type="button"
              >
                <Icon
                  className="mr2"
                  name="lined-arrow-left"
                />
                <span>{ title }</span>
              </button>
              <ul>
                {
                  links.map(({ href: linkHref, title: linkTitle }, idx) => (
                    <li key={ idx }>
                      <a
                        className={
                          classnames(
                            'pv5 bb b--black-10 db flex items-center fw-medium',
                            { bw0: idx === links.length - 1 }
                          )
                        }
                        href={ linkHref }
                      >
                        { linkTitle }
                      </a>
                    </li>
                  ))
                }
              </ul>
            </div>
          </MobileMenu>
      }
    </Fragment>
  );
}

GenericMobileHeaderDropdownContentSubNav.propTypes = {
  href: PropTypes.string,
  isOpen: PropTypes.bool,
  links: PropTypes.array,
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  title: PropTypes.string.isRequired
};

GenericMobileHeaderDropdownContentSubNav.defaultProps = {
  href: null,
  isOpen: false,
  links: null,
  onClose: null,
  onOpen: null
};
